import {
  ON_SELECT_TO_CHANGE_UNIT,
  ON_CLEAR_TO_CHANGE_UNIT,
  REQUEST_UPDATE_UNIT_SUPPORT,
  RESPONSE_UPDATE_UNIT_SUPPORT,
  REQUEST_UPDATE_UNIT_SUPPORT_FAIL,
  REQUEST_UNIT_SHARED,
  RESPONSE_UNIT_SHARED,
  REQUEST_UNIT_SHARED_FAIL,
  REQUEST_UNIT_UN_SHARED,
  RESPONSE_UNIT_UN_SHARED,
  REQUEST_UNIT_UN_SHARED_FAIL,
  REQUEST_UNIT_SETTINGS,
  RESPONSE_UNIT_SETTINGS,
  REQUEST_UNIT_SETTINGS_FAIL,
  REQUEST_UPDATE_UNIT_SETTING,
  RESPONSE_UPDATE_UNIT_SETTING,
  REQUEST_UPDATE_UNIT_SETTING_FAIL,
  REQUEST_UPDATE_UNIT_INFORMATION,
  RESPONSE_UPDATE_UNIT_INFORMATION,
  REQUEST_UPDATE_UNIT_INFORMATION_FAIL,
} from "../actions/unitActions";

import { states } from "./queriesStates";

const initialState = {
  changeUnitDataState: states.NOT_REQUESTED,
  changeUnitSharedDataState: states.NOT_REQUESTED,
  unitSettingsDataState: states.NOT_REQUESTED,
  updateUnitSettingDataState: states.NOT_REQUESTED,
  updateUnitInformationDataState: states.NOT_REQUESTED,
  currentUnit: null,
  unitSettings: { settingsGroups: [] },
  errors: [],
};

const changeUnitReducer = (state = initialState, action) => {
  switch (action.type) {
    case ON_SELECT_TO_CHANGE_UNIT:
      return Object.assign({}, state, {
        currentUnit: action.unit,
      });
    case ON_CLEAR_TO_CHANGE_UNIT:
      return Object.assign({}, state, {
        currentUnit: null,
        unitSettings: [],
      });

    case REQUEST_UPDATE_UNIT_SUPPORT:
      return Object.assign({}, state, {
        changeUnitDataState: states.REQUEST,
      });
    case RESPONSE_UPDATE_UNIT_SUPPORT:
      const currentUnit = state.currentUnit;

      currentUnit.title = action.data.title;
      currentUnit.registerNumber = action.data.registerNumber;
      currentUnit.inActive = action.data.inActive;

      return Object.assign({}, state, {
        changeUnitDataState: states.READY,
        currentUnit: currentUnit,
      });
    case REQUEST_UPDATE_UNIT_SUPPORT_FAIL:
      return Object.assign({}, state, {
        changeUnitDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_UNIT_SHARED:
      return Object.assign({}, state, {
        changeUnitSharedDataState: states.REQUEST,
      });
    case RESPONSE_UNIT_SHARED:
      const _changeUnit = state.currentUnit;
      _changeUnit.companies = _changeUnit.companies.concat([action.data]);

      return Object.assign({}, state, {
        changeUnitSharedDataState: states.READY,
        currentUnit: _changeUnit,
      });
    case REQUEST_UNIT_SHARED_FAIL:
      return Object.assign({}, state, {
        changeUnitSharedDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_UNIT_UN_SHARED:
      return Object.assign({}, state, {
        changeUnitSharedDataState: states.REQUEST,
      });
    case RESPONSE_UNIT_UN_SHARED:
      const _changeUnitUnShared = state.currentUnit;
      _changeUnitUnShared.companies = _changeUnitUnShared.companies.filter((x) => {
        return x.id != action.data.id;
      });

      return Object.assign({}, state, {
        changeUnitSharedDataState: states.READY,
        currentUnit: _changeUnitUnShared,
      });
    case REQUEST_UNIT_UN_SHARED_FAIL:
      return Object.assign({}, state, {
        changeUnitSharedDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_UNIT_SETTINGS:
      return Object.assign({}, state, {
        unitSettingsDataState: states.REQUEST,
        unitSettings: { settingsGroups: [] },
      });
    case RESPONSE_UNIT_SETTINGS:
      return Object.assign({}, state, {
        unitSettingsDataState: states.READY,
        unitSettings: action.data,
      });
    case REQUEST_UNIT_SETTINGS_FAIL:
      return Object.assign({}, state, {
        unitSettingsDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_UPDATE_UNIT_SETTING:

      return Object.assign({}, state, {
        updateUnitSettingDataState: states.REQUEST,
      });
    case RESPONSE_UPDATE_UNIT_SETTING:

      return Object.assign({}, state, {
        updateUnitSettingDataState: states.READY,
        unitSettings: action.data,
      });
    case REQUEST_UPDATE_UNIT_SETTING_FAIL:
      return Object.assign({}, state, {
        updateUnitSettingDataState: states.FAILURE,
        errors: action.data["setting.Value"],
      });

    case REQUEST_UPDATE_UNIT_INFORMATION:
      return Object.assign({}, state, {
        updateUnitInformationDataState: states.REQUEST,
      });

    case RESPONSE_UPDATE_UNIT_INFORMATION:
      const _currentUnit = state.currentUnit;

      _currentUnit.title = action.data.title;
      _currentUnit.registerNumber = action.data.registerNumber;
      _currentUnit.number = action.data.number;

      return Object.assign({}, state, {
        updateUnitInformationDataState: states.READY,
        currentUnit: _currentUnit,
      });

    case REQUEST_UPDATE_UNIT_INFORMATION_FAIL:
      return Object.assign({}, state, {
        updateUnitInformationDataState: states.FAILURE,
        errors: action.data,
      });

    default:
      return state;
  }
};

export default changeUnitReducer;
